/* eslint-disable react-hooks/exhaustive-deps */
import { useSelect } from 'downshift';
import React, { useEffect, useState } from 'react';
import { useLocation } from 'wouter';

import { useCategories } from '../hooks/useCategories';

const BrandsCategories = ({ onSelect }) => {
    const { data: categoriesData, isError } = useCategories();
    const [, setLocation] = useLocation();

    let category = window.location.pathname.substring(window.location.pathname.lastIndexOf('/') + 1);
    if (category === 'brand') {
        category = '';
    }

    const defaultItem = { Title: 'All Categories', NavigationUrlSlug: '' };
    const items = [defaultItem, ...(categoriesData || [])];
    const [selectedItem, setSelectedItem] = useState(defaultItem);

    useEffect(() => {
        if (category) {
            const item = items.find((item) => item.NavigationUrlSlug === category) || defaultItem;
            setSelectedItem(item);
            onSelect(category);
        }
    }, [category, onSelect, items, defaultItem]);

    const handleSelectedItemChange = (changes) => {
        setSelectedItem(changes.selectedItem);
        if (changes.selectedItem.Title === 'All Brands') {
            setLocation(`/pages/brand`);
            onSelect('');
        } else {
            const dimensionValue = encodeURIComponent(changes.selectedItem.NavigationUrlSlug);
            setLocation(`/pages/brand/${dimensionValue}`);
            onSelect(changes.selectedItem.NavigationUrlSlug);
        }
    };

    const handleKeyDown = (event) => {
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
            event.preventDefault();
        }
    };

    const { isOpen, getToggleButtonProps, getMenuProps, highlightedIndex, getItemProps, getLabelProps } = useSelect({
        items,
        selectedItem,
        onSelectedItemChange: handleSelectedItemChange,
        onStateChange: ({ highlightedIndex }) => {
            const element = document.querySelector(`[data-highlighted-index="${highlightedIndex}"]`);
            if (element) {
                element.scrollIntoView({ block: 'nearest' });
            }
        },
    });

    if (isError) return <div>Error loading categories.</div>;

    return (
        <div className="relative flex flex-col md:flex-row">
            <span className="pb-5 text-xl font-bold md:pb-0 md:text-2xl">
                {selectedItem.Title === 'All Categories' ? 'All Brands' : selectedItem.Title}
            </span>
            <div className="relative flex items-center space-x-4 md:ml-auto">
                <span className="text-nowrap text-base font-semibold" {...getLabelProps()}>
                    Filter by category
                </span>
                <div className="relative flex flex-col">
                    <button
                        {...getToggleButtonProps({
                            onKeyDown: handleKeyDown,
                        })}
                        className="mt-1.5 flex w-44 border-x-0 border-b border-t-0 border-solid pb-1 text-sm font-light text-black md:w-64"
                        style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'clip' }}
                    >
                        <span className="truncate">{selectedItem.Title}</span>
                        <span className="relative bottom-1 right-2 ml-auto mt-1 h-4 w-4 pb-1.5">
                            <svg
                                width="24"
                                height="24"
                                xmlns="http://www.w3.org/2000/svg"
                                xmlnsXlink="http://www.w3.org/1999/xlink"
                            >
                                <defs>
                                    <path
                                        d="m12 10.414 5.293 5.293a1 1 0 0 0 1.414-1.414l-6-6a1 1 0 0 0-1.414 0l-6 6a1 1 0 0 0 1.414 1.414L12 10.414Z"
                                        id="a"
                                    />
                                </defs>
                                <g fill="none" fillRule="evenodd" transform="rotate(180, 12, 12)">
                                    <mask id="b" fill="#fff">
                                        <use xlinkHref="#a" />
                                    </mask>
                                    <use fill="#000" fillRule="nonzero" xlinkHref="#a" />
                                    <g mask="url(#b)" fill="#000">
                                        <path d="M0 0h24v24H0z" />
                                    </g>
                                </g>
                            </svg>
                        </span>
                    </button>
                    <ul
                        {...getMenuProps()}
                        className={`${
                            isOpen ? 'block' : 'hidden'
                        } absolute right-0 top-full z-10 max-h-80 w-full overflow-y-auto border border-solid border-neutral-200 bg-white p-0 px-1 py-1 text-sm shadow-md`}
                    >
                        {isOpen &&
                            items.map((item, index) => (
                                <li
                                    className={`flex cursor-pointer items-center py-0.5 pl-2 ${
                                        highlightedIndex === index
                                            ? 'z-10 bg-blue-500 px-3 text-white shadow-sm'
                                            : 'text-gray-700'
                                    }`}
                                    key={`${item.Title}${index}`}
                                    data-highlighted-index={index}
                                    {...getItemProps({ item, index })}
                                >
                                    {item.Title}
                                </li>
                            ))}
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default BrandsCategories;
